import React from 'react';
import styled from 'styled-components';
import ProjectCard, { ProjectCardProps } from './ProjectCard/ProjectCard';

const Container = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const Heading = styled.h2`
  margin: 0;
  font-size: 40px;
  font-family: 'JetBrains Mono', monospace;
  font-weight: 700;
  display: inline-block;
  width: fit-content;
  background: linear-gradient(45deg, #34d399, #06b6d4);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;

  body.dark & {
    background: linear-gradient(45deg, #f472b6, #fb923c);
    background-clip: text;
    -webkit-background-clip: text;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const PROJECTS: ProjectCardProps[] = [
  {
    id: 'tilde',
    title: 'Tilde',
    description: 'A geometry definition language with a browser playground.',
    tags: ['TypeScript', 'Language Design', 'Geometry'],
    image: '/projects/tilde/tilde.png',
    href: 'https://tilde.heyitssuvi.com/',
  },
  {
    id: 'weenix',
    title: 'Weenix',
    description: 'A Unix-like OS kernel built from scratch in C — processes & threads, VFS, and virtual memory with demand paging and copy-on-write.',
    tags: ['C', 'Operating Systems', 'Kernel'],
    image: '/projects/weenix/boot.png',
  },
  {
    id: 'parallel-raytracer',
    title: 'Parallel Raytracer',
    description: 'A C++ raytracer parallelized with OpenMP and MPI, benchmarked for strong and weak scaling on USC\'s CARC cluster.',
    tags: ['C++', 'OpenMP', 'MPI', 'Computer Graphics'],
    image: '/projects/parallel-raytracer/Reflections.png',
  },
  {
    id: 'processing-raytracer',
    title: 'Raytracer',
    description: 'A raytracer built in Processing following Ray Tracing in One Weekend — extended with triangle support for constructing complex hollow shapes.',
    tags: ['Processing', 'Computer Graphics', 'Rendering'],
    image: '/projects/raytracer/Tetrahedron_floating_with_a_sphere_buddy.png',
  },
  {
    id: 'raster-renderer',
    title: 'Raster Renderer',
    description: 'A software rasterizer built from scratch — full graphics pipeline, Phong shading, perspective-correct textures, MSAA, and normal mapping.',
    tags: ['C++', 'Python', 'Computer Graphics', 'Rendering'],
    image: '/projects/raster-renderer/hw4_phong.png',
    imageStyle: { objectPosition: 'center 35%' },
    hoverEffect: 'waves',
  },
  {
    id: 'stealth-in-the-shadows',
    title: 'Stealth in the Shadows',
    description: 'A 2D stealth platformer built in Unity by a four-person team — toggle lights, mix colors, and shadow-dive through 15 hand-designed levels.',
    tags: ['Unity', 'C#', 'Game Development'],
    image: '/projects/stealth-in-the-shadows/level-8-color-mixing.png',
    hoverEffect: 'orbit',
  },
];

const ProjectTable: React.FC = () => (
  <Container>
    <Heading>Projects</Heading>
    <Grid>
      {PROJECTS.map(p => <ProjectCard key={p.id} {...p} />)}
    </Grid>
  </Container>
);

export default ProjectTable;
